<template>
  <main class="activity-page">
    <van-cell v-if="imei" :title="device.name || $t('当前设备')" :label="imei" />
    <activity-history v-if="imei" />
    <p v-else class="no-device">{{ $t('请先选择设备') }}</p>
  </main>
</template>
<script>
import {Cell} from 'vant'
import {readCommonParam, getImei} from '@/util/session-storage-utils'
import {getBaseInfo} from '@/api/device'
import ActivityHistory from '../info/ActivityHistory.vue'
export default {
  components: {ActivityHistory, [Cell.name]: Cell},
  data() { return {imei: '', device: {}} },
  created() {
    readCommonParam(this)
    document.title = this.$t('运动历史')
    this.imei = this.$route.query._imei || getImei()
    if (this.imei) getBaseInfo(this.imei).then(res => { this.device = res.data || {} }).catch(() => {})
  }
}
</script>
<style scoped>
.activity-page { min-height: 100vh; font-size: 14px; line-height: 1.5; padding-bottom: 24px; }
.no-device { padding: 32px 16px; text-align: center; color: #969799; font-size: 14px; }
</style>
